module.exports = __webpack_public_path__ + "static/img/TANNER-ARMSTRONG.bcd3cc6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/TANNER-ARMSTRONG.jpg
// module id = cwB3
// module chunks = 0